import React, { useState, useEffect } from "react";
import styles from "./TopCountry.module.sass";
import cn from "classnames";
import Card from "../../../components/Card";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import useDarkMode from "use-dark-mode";
import { getSourcesData } from "../../../services/prospectDashboard.service";

const TopSource = ({ className, sourcesData }) => {
    const darkMode = useDarkMode(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                
                // Si les données sont passées en props, les utiliser
                if (sourcesData) {
                    setData(sourcesData.sources || []);
                    setError(null);
                } else {
                    // Sinon, récupérer les données via l'API
                    const result = await getSourcesData();
                    setData(result.sources || []);
                    setError(null);
                }
            } catch (err) {
                console.error("Failed to fetch sources data:", err);
                setError("Impossible de charger les données des sources.");
                // Données par défaut en cas d'erreur
                setData([
                    { name: 'Jobboards', views: 0 },
                    { name: 'Réseaux sociaux', views: 0 },
                    { name: 'Site Web', views: 0 },
                    { name: 'Recommandations', views: 0 },
                    { name: 'Partenaires', views: 0 },
                    { name: 'Autres', views: 0 }
                ]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [sourcesData]);

    return (
        <Card
            className={cn(styles.card, className)}
            title="Sources"
            classTitle="title-red"
        >
            {loading && <p>Chargement des sources...</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
            {!loading && !error && data.length > 0 && (
                <div className={styles.chart}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                        width={500}
                        height={300}
                        data={data}
                        layout="vertical"
                        margin={{
                            top: 0,
                            right: 0,
                            left: 5,
                            bottom: 0,
                        }}
                        barSize={24}
                        barGap={8}
                    >
                        <CartesianGrid
                            strokeDasharray="none"
                            stroke={darkMode.value ? "#272B30" : "#EFEFEF"}
                            horizontal={false}
                        />
                        <XAxis
                            type="number"
                            axisLine={false}
                            tickLine={false}
                            tick={{
                                fontSize: 12,
                                fontWeight: "500",
                                fill: "#6F767E",
                            }}
                            padding={{ left: 10 }}
                        />
                        <YAxis
                            type="category"
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                            tick={{
                                fontSize: 12,
                                fontWeight: "500",
                                fill: "#6F767E",
                            }}
                        />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: "#272B30",
                                borderColor: "rgba(255, 255, 255, 0.12)",
                                borderRadius: 8,
                                boxShadow:
                                    "0px 4px 8px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.1), inset 0px 0px 1px #000000",
                            }}
                            labelStyle={{
                                fontSize: 12,
                                fontWeight: "500",
                                color: "#fff",
                            }}
                            itemStyle={{
                                padding: 0,
                                textTransform: "capitalize",
                                fontSize: 12,
                                fontWeight: "600",
                                color: "#fff",
                            }}
                            cursor={{ fill: "#f3f2f3" }}
                        />
                        <Bar dataKey="views" fill="#B5E4CA" />
                    </BarChart>
                </ResponsiveContainer>
                </div>
            )}
            {!loading && !error && data.length === 0 && (
                <p>Aucune donnée de source disponible.</p>
            )}
        </Card>
    );
};

export default TopSource;
